<!-- Stacked while the row is narrow, side by side once there is room. A container query, because
     this sits in a drawer far narrower than the window. -->
<div class="dm-flex dm-flex-column dm-gap-16 @md:dm-flex-row @md:dm-items-start">
  <dm-avatar size="xl" [imgsrc]="previewUrl()" [initials]="initials() || '-'" [alt]="avatarLabel" />
  <div class="dm-flex dm-flex-column dm-gap-8 dm-flex-1">
    <dm-file-drop-zone
      uploadtext="Zum Hochladen klicken"
      i18n-uploadtext="@@common.upload.click"
      dragdroptext="oder per Drag & Drop"
      i18n-dragdroptext="@@common.upload.dragdrop"
      [disabled]="disabled()"
      [accept]="accept()"
      [maxsize]="maxBytes()"
      [hint]="hint()"
      [invalidtypelabel]="wrongTypeMessage"
      [invalidsizlabel]="tooLargeMessage()"
      (dmDropZoneFiles)="onPicked($event.detail)"
      (dmDropZoneUnacceptedFiles)="onRejected(wrongTypeMessage)"
      (dmDropZoneSizeLimitExceed)="onRejected(tooLargeMessage())"
    />
    @if (previewUrl()) {
      <div>
        <dm-button color="tertiary" size="sm" dmType="button" [disabled]="disabled()" (click)="onRemove()">
          <dm-icon slot="leading" name="trash-01" />
          <span i18n="@@benutzerverwaltung.form.benutzerfotoEntfernen">Foto entfernen</span>
        </dm-button>
      </div>
    }
  </div>
</div>
